import React from 'react';
import { Link } from 'react-router-dom';
import { siteData } from '../data';
import { Facebook, Instagram } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-white text-stone-900 py-12 border-t border-stone-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 border-b border-stone-100 pb-12">
          <div>
            <Link to="/" className="block mb-6">
              <img 
                src="https://assets.auxodev.dk/assets/827bf07b-63d5-4b3e-a53e-0e890a6a1d87/69f2413c-fcae-456a-8125-774bce14700a.png" 
                alt="Pai Thai Massage Logo" 
                className="h-20 w-auto"
              />
            </Link>
            <p className="text-stone-600 max-w-xs mb-6">
              Traditionel thailandsk massage i hjertet af Holbæk. Vi hjælper dig med at finde ro og balance.
            </p>
            <div className="flex space-x-6">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-stone-600 hover:text-[#b0a697] transition-colors duration-300"
                aria-label="Følg os på Facebook"
              >
                <Facebook className="w-6 h-6" />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-stone-600 hover:text-[#b0a697] transition-colors duration-300"
                aria-label="Følg os på Instagram"
              >
                <Instagram className="w-6 h-6" />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-serif font-medium mb-6 uppercase tracking-wider">Hurtige links</h3>
            <ul className="space-y-4">
              <li><Link to="/" className="text-stone-600 hover:text-[#b0a697] transition-colors text-sm tracking-wide uppercase">forside</Link></li>
              <li><a href="/#behandlinger" className="text-stone-600 hover:text-[#b0a697] transition-colors text-sm tracking-wide uppercase">behandlinger</a></li>
              <li><Link to="/priser" className="text-stone-600 hover:text-[#b0a697] transition-colors text-sm tracking-wide uppercase">priser</Link></li>
              <li><a href="/#kontakt" className="text-stone-600 hover:text-[#b0a697] transition-colors text-sm tracking-wide uppercase">kontakt</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-serif font-medium mb-6 uppercase tracking-wider">Kontakt</h3>
            <ul className="space-y-4 text-stone-600">
              <li>{siteData.address}</li>
              <li>{siteData.phone}</li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 flex flex-col sm:flex-row justify-between items-center text-stone-500 text-sm">
          <p>© {new Date().getFullYear()} {siteData.name}. Alle rettigheder forbeholdes.</p>
          <div className="mt-4 sm:mt-0 space-x-6">
            <a href="#" className="hover:text-[#b0a697] transition-colors">Privatlivspolitik</a>
            <a href="#" className="hover:text-[#b0a697] transition-colors">Handelsbetingelser</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
